import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import { CloseIcon } from '../../../icons/CloseIcon';
import { ErrorIcon } from '../../../icons/ErrorIcon';
import { CircularButton } from '../../CircularButton/CircularButton';
import styles from './ErrorToast.module.css';

export type ErrorToastProps = {
  className?: string;
  description?: string;
  id: number | string;
  onClose: () => void;
  title: string;
};

export const ErrorToast: FunctionComponent<ErrorToastProps> = ({
  className,
  description,
  id,
  onClose,
  title,
}) => {
  return (
    <div className={cx(styles.root, className)} key={id}>
      <div className={styles.container}>
        <ErrorIcon />
        <div className={styles.textContent}>
          <span className={styles.title}>{title}</span>
          <span>{description}</span>
        </div>
      </div>
      <div>
        <CircularButton className={styles.closeButton} onClick={onClose}>
          <CloseIcon />
        </CircularButton>
      </div>
    </div>
  );
};
